<template>
    <div>
        <v-row>
            <ActionDropdown
                :items="actions"
                context="Usage"
                :alvqa="alvqa"
                cols="3"
            />
            <ImportButton
                :items="importOptions"
                context="UsageImport"
                cols="3"
                :alvqa="alvqa"
            />
            <v-col
                cols="4"
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats
                    context="Usage"
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col cols="12" class="pt-0">
                <v-alert
                    type="info"
                    dense
                    text
                    class="mb-0"
                    :alvqa="alvqa + '-list-hint-compare'"
                >{{ $t('lang_PUBLISHING_USAGE_CAPTION_HINT_COMPARE') }}</v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ImportButton from '@/components/_buttons/ImportButton'
import { DATA_TYPES } from './usageOptions'

export default {
    name: 'UsageTopSlot',
    components: {
        ActionDropdown,
        BaseHeaderStats,
        ImportButton
    },
    data() {
        return {
            alvqa: 'publishing-usage'
        }
    },
    computed: {
        importOptions() {
            return DATA_TYPES.map(type => ({ value: type.value, text: this.$t(type.text), alvqa: this.alvqa + '-list-import-dropdown-' + type.value }))
        },
        actions() {
            const action = (value, text) => ({ value, text: this.$t(text), alvqa: this.alvqa + '-list-action-dropdown-' + value })
            return [
                action('compare', 'lang_PUBLISHING_USAGE_ACTION_COMPARE'),
                action('review', 'lang_PUBLISHING_USAGE_ACTION_REVIEW'),
                action('download', 'lang_GENERAL_CAPTION_ICON_DOWNLOAD'),
                action('delete', 'lang_GENERIC_CAPTION_DELETE')
            ]
        }
    }
}
</script>
